module.exports = {
  ModuleName: '模块名称',
  OperationChangeTime: '操作变更时间',
  Operator: '操作人',
  To: '至',
  Close: '关闭',
  SerialNumber: '流水号',
  OperationTime: '操作时间',
  QueryScheme: '查询方案',
  QuickSearchBusinessCode: '快捷检索:业务编号',
  YouDidntOpen: '你没有打开',
  FinancialAudit: '财务审核',
  ModulePermissions: '模块的权限',
  IfTheDataLoadingYears: '若选的日期范围大于2年，会影响数据加载速度，确定查询两年外的数据吗？',
  StartDate: '开始日期',
  EndDate: '结束日期',
  ContentDescription: '内容描述',
  Name: '名称'
}
